import { render } from "./SectionsPageView.vue?vue&type=template&id=b1c6561c&scoped=true"
import script from "./SectionsPageView.vue?vue&type=script&lang=js"
export * from "./SectionsPageView.vue?vue&type=script&lang=js"

import "./SectionsPageView.vue?vue&type=style&index=0&id=b1c6561c&lang=scss"
import "./SectionsPageView.vue?vue&type=style&index=1&id=b1c6561c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c6561c"]])

export default __exports__